import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-popup-confirmacion',
    templateUrl: './popup-confirmacion.component.html',
    styleUrls: ['./popup-confirmacion.component.css'],
    standalone: true
})
export class PopupConfirmacionComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<PopupConfirmacionComponent>) { }
  @Input('dialogData') dialogData: any;

  ngOnInit(): void { }

  close(res: String) {
    if (res === 'Si') {
      this.dialogRef.close(res)
    } else {
      this.dialogRef.close()
    }
  }

}
